import { useState, useEffect } from "react";
import { Form, Badge, FormProps } from "antd";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { TaskFilterValues } from "../lib/types/TaskFilterValues.interface";
import { taskFilterFields } from "../lib/constants/taskFilterFields";
import { buildCompleteFilterForm } from "@/lib/helpers/buildCompleteFilterForm";
import { Modal } from "@/components/v2";
import { Button, Card, CardFooter, Input, Select } from "@rumbledirect/ui";

interface TasksFilterModalProps {
  setTaskFilters: (filterValues: TaskFilterValues) => void;
  taskFilters?: TaskFilterValues;
}

export const TasksFilterModal = ({
  setTaskFilters,
  taskFilters = {},
}: TasksFilterModalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const activeFiltersCount = Object.values(taskFilters).filter(
    (value) => value != null && value !== "",
  ).length;

  useEffect(() => {
    // Write every known field so cleared filters are reset rather than merged.
    form.setFieldsValue(buildCompleteFilterForm(taskFilterFields, taskFilters));
  }, [taskFilters, form]);

  const handleSubmit: FormProps<TaskFilterValues>["onFinish"] = (values) => {
    const filteredValues: TaskFilterValues = Object.fromEntries(
      Object.entries(values).filter(
        ([, value]) => value != null && value !== "",
      ),
    );

    setTaskFilters(filteredValues);
    setIsModalOpen(false);
  };

  const handleReset = () => {
    form.resetFields();
    setTaskFilters({});
    setIsModalOpen(false);
  };

  return (
    <>
      <Badge count={activeFiltersCount} size="default">
        <Button icon={<FilterOutlined />} onClick={() => setIsModalOpen(true)}>
          Filters
        </Button>
      </Badge>

      <Modal open={isModalOpen} onCancel={() => setIsModalOpen(false)}>
        <Card title="Taken filters">
          <p className="mb-6 mt-3">
            Filter de taken op basis van de onderstaande criteria.
          </p>

          <Form
            form={form}
            layout="vertical"
            initialValues={taskFilters}
            onFinish={handleSubmit}
          >
            {taskFilterFields.map((field) => (
              <Form.Item
                key={field.name}
                name={field.name}
                label={field.label}
                rules={field.rules}
              >
                {field.type === "select" ? (
                  <Select
                    placeholder={field.placeholder}
                    allowClear
                    options={field.options}
                  />
                ) : (
                  <Input placeholder={field.placeholder} allowClear />
                )}
              </Form.Item>
            ))}

            <CardFooter>
              <Button onClick={() => setIsModalOpen(false)}>Annuleren</Button>

              <Button onClick={handleReset} className="ml-auto">
                Filters wissen
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                icon={<SearchOutlined />}
              >
                Filter toepassen
              </Button>
            </CardFooter>
          </Form>
        </Card>
      </Modal>
    </>
  );
};
